import { multiply } from '@pushpay/styles';
import { palette, textColor } from '../color-token';
import { getFont } from './font';
import { getTextStyles } from './text-styles';
export function getTypography(args) {
  const FONT = getFont(args);
  const TEXT_STYLES = getTextStyles(FONT);

  function fontStyle(key) {
    const {
      WEIGHT,
      SIZE,
      LINE_HEIGHT,
      FAMILY
    } = TEXT_STYLES[key];
    return `${WEIGHT} ${SIZE} / ${LINE_HEIGHT} ${FAMILY}`;
  }

  const {
    BASE_SIZE,
    FAMILY
  } = FONT;
  return {
    TEXT_STYLES,
    FONT,
    BASE_SIZE,

    /**
     * @deprecated use colors['product-color'] instead
     */
    // eslint-disable-next-line deprecation/deprecation
    LINK_COLOR: palette['palette-blue'],

    /**
     * @deprecated use colors['color-text-placeholder'] instead
     */
    // eslint-disable-next-line deprecation/deprecation
    PLACEHOLDER_COLOR: palette['palette-grey'],
    //  NEUTRALS.GREY_COOL;

    /**
     * @deprecated use colors['color-text-default'] instead
     */
    // eslint-disable-next-line deprecation/deprecation
    BODY_COLOR: textColor['color-text-default'],
    // NEUTRALS.GREY_COOL_DARK_300;

    /**
     * @deprecated use colors['color-text-heading'] instead
     */
    // eslint-disable-next-line deprecation/deprecation
    HEADLINE_COLOR: textColor['color-text-heading'],
    // NEUTRALS.GREY_COOL_DARK_400;
    HEADLINE_1: fontStyle('HEADING_1'),
    HEADLINE_2: fontStyle('HEADING_2'),
    HEADLINE_3: fontStyle('HEADING_3'),
    HEADLINE_4: fontStyle('HEADING_4'),
    BODY_1: fontStyle('BODY_1'),
    BODY_2: fontStyle('BODY_2'),
    BUTTONS: fontStyle('BUTTON'),
    TAGS: fontStyle('TAG'),
    SIDE_MENU: fontStyle('SIDE_MENU'),
    // TODO: These should be 15px with line height 20px but will we actually line wrap in fields? Replace with something else.
    FIELD_VALUE: `${multiply(BASE_SIZE, 15 / 16)} ${FAMILY}`,
    FIELD_VALIDATION_ERROR: `${multiply(BASE_SIZE, 15 / 16)} ${FAMILY}`,
    REQUIRED_TEXT: `italic ${multiply(BASE_SIZE, 12 / 16)} ${FAMILY}`
  };
}